"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useCarePlanContext } from "./care-plan";
import { StepDetail } from "./step-detail";
interface StepCardPopoverProps {
  stepId: string;
  children: ReactNode;
}
export function StepCardPopover(t0) {
  const $ = _c(10);
  const {
    stepId,
    children
  } = t0;
  const {
    state: t1,
    actions: t2
  } = useCarePlanContext();
  const {
    selectedStepId
  } = t1;
  const {
    selectStep
  } = t2;
  const isOpen = selectedStepId === stepId;
  let t3;
  if ($[0] !== selectStep || $[1] !== stepId) {
    t3 = open => selectStep(open ? stepId : null);
    $[0] = selectStep;
    $[1] = stepId;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <PopoverTrigger onClick={_temp}>{children}</PopoverTrigger>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PopoverContent side="right" align="start" className="w-80" collisionPadding={16} onClick={_temp2}><StepDetail /></PopoverContent>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isOpen || $[7] !== t3 || $[8] !== t4) {
    t6 = <Popover open={isOpen} onOpenChange={t3}>{t4}{t5}</Popover>;
    $[6] = isOpen;
    $[7] = t3;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}